import Vue from 'vue';
import {
  clone, cloneDeep, orderBy, findIndex,
} from 'lodash';
import api from 'src/api';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const SET_FETCHING = 'SET_FETCHING';
export const SET_STOP_FETCHING = 'SET_STOP_FETCHING';

const msToMin = 60000;
const timeoutsKeys = [
  'autoholdChatTimeout',
  'autocloseMsgTimeout',
  'autocloseChatTimeout',
  'inactiveChatAutocloseMsg',
];
const data = {
  timeouts: [],
  fething: false,
};

const actions = {
  fetchTimeouts({ commit }) {
    commit(SET_FETCHING);
    return api.getTimeouts().then((res) => {
      const parseRes = res.map((item) => {
        const parseTimeouts = cloneDeep(item);
        timeoutsKeys.forEach((key) => {
          // переводим из мс в мин
          if (key !== 'inactiveChatAutocloseMsg' && parseTimeouts[key]) parseTimeouts[key] /= msToMin;
          if (!parseTimeouts[key]) parseTimeouts[key] = null;
        });
        return ({
          ...parseTimeouts,
        });
      });
      commit('SYNC', parseRes);
    })
      .catch((err) => {
        commit(SET_STOP_FETCHING);
        throw err;
      });
  },
  createTimeout({ commit }, { model }) {
    const parseTimeouts = cloneDeep(model);
    timeoutsKeys.forEach((key) => {
      // переводим из мс в мин
      if (key !== 'inactiveChatAutocloseMsg' && parseTimeouts[key]) {
        parseTimeouts[key] = Math.round(parseTimeouts[key] * msToMin);
      }
      if (!parseTimeouts[key]) parseTimeouts[key] = null;
    });
    const parseModel = ({
      ...parseTimeouts,
    });
    return api.createTimeout(parseModel).then((res) => {
      commit('ADD_TIMEOUT', res);
    });
  },
  updateTimeout({ commit }, { id, model }) {
    const parseTimeouts = cloneDeep(model);
    timeoutsKeys.forEach((key) => {
      // переводим из мс в мин
      if (key !== 'inactiveChatAutocloseMsg' && parseTimeouts[key]) {
        parseTimeouts[key] = Math.round(parseTimeouts[key] * msToMin);
      }
      if (!parseTimeouts[key]) parseTimeouts[key] = null;
    });
    const parseModel = ({
      ...parseTimeouts,
    });
    return api.updateTimeout(id, parseModel).then((res) => {
      commit('UPDATE_TIMEOUT', res);
    });
  },
  removeTimeout({ commit }, id) {
    commit(SET_FETCHING);
    return api.deleteTimeout(id)
      .then(() => commit('REMOVE_TIMEOUT', id))
      .catch((err) => {
        commit(SET_STOP_FETCHING);
        throw err;
      });
  },
};

const mutations = {
  SET_FETCHING(state) {
    state.fetching = true;
  },
  SET_STOP_FETCHING(state) {
    state.fetching = false;
  },
  SYNC(state, payload) {
    state.timeouts = cloneDeep(orderBy(payload, 'name'));
    mutations.SET_STOP_FETCHING(state);
  },
  UPDATE_TIMEOUT(state, res) {
    const { id } = res;
    const { timeouts } = state;
    const index = findIndex(timeouts, { id });
    Vue.set(timeouts, index, { ...timeouts[index], ...res });
  },
  REMOVE_TIMEOUT(state, id) {
    const { timeouts } = state;
    Vue.delete(timeouts, findIndex(timeouts, { id }));
  },
  ADD_TIMEOUT(state, res) {
    state.timeouts.push(clone(res));
  },
};

const getters = {
  getTimeoutById(state) {
    const { timeouts } = state;
    return (id) => (timeouts[findIndex(timeouts, { id })]);
  },
};

const store = {
  namespaced: true,
  state: data,
  mutations,
  getters,
  actions,
};

export default store;
